import { HTTP_METHOD } from '../../../_types/http-method';
import request from '../../../app/utils/request';
import { config } from '../../../config';

import type { User } from './request.type';

const CMS_V1 = config().CMS_API.v1;

export function getUser({ email }: { email: string }) {
  return request<User>({
    url: `${CMS_V1}/users/${email}`,
    options: { method: HTTP_METHOD.get },
  });
}
